<template>
  <div class="col-3-center">
    <p>
      Im Prozess zur Erstellung des räumlichen Leitbildes wurden für die Bürger
      bereits zahlreiche Beteiligungsmöglichkeiten angeboten. Häufig erfolgen
      Beteiligungsangebote nur während der eigentlichen Analyse, die Stadt Dachau
      entschied die Beteiligung kontinuierlich in den gesamten Prozess einzubauen.
    </p>
    <!-- <p>
      Zum und vor dem Finale des Leitbildentwurfs konnte in einem ganztägigen
      Workshop ein unmittelbarer inhaltlicher Dialog mit der Stadtverwaltung, den
      Stadträten und dem Fachbüro erfolgen – ergänzt u. a. durch weitere Impulse
      aus Fachvorträgen
    </p>-->

    <p>
      Die Dokumentation zum Download als PDF finden Sie
      <router-link to="/projekt/downloads">hier</router-link>.
    </p>
    <img
      :src="require('@/assets/fotos/buergerwerkstatt/buergerwerkstatt.png')"
      alt="buergerwerkstatt"
    />
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: "Bürgerwerkstatt"
  }
};
</script>

<style lang="scss" scoped>
img {
  width: 100%;
}
</style>